<template lang="html">
  <div class="form-group" :class="groupClass"><span v-if="!noLabelTag" class="control-label"
                                                    :class="labelClass"><slot
      name="labelinner">{{ labelText }}</slot></span>
    <slot></slot>
    <slot name="hints"></slot>
    <slot name="errors"></slot>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'payout-form-group',
})
export default class PayoutFormGroup extends Vue {
  @Prop({ default: null })
  label?: string

  @Prop({ default: false })
  required!: boolean

  @Prop({ default: false })
  hasErrors!: boolean

  @Prop({ default: false })
  noLabelTag!: boolean

  get groupClass(): any {
    return { 'has-error': this.hasErrors, 'form-group-has-error': this.hasErrors };
  }

  get labelText(): string {
    return this.label && (this.label.length > 0) ? this.label : '';
  }

  get labelClass(): any {
    return { required: this.required };
  }
}
</script>

<style scoped lang="less">

</style>

<style lang="less">
.tarnsfer_form {
  .form-group {
    &.form-group__label_align_start {
      align-items: start;
      .control-label {
        margin-top: 15px;
      }
    }

  }
}

</style>
